<template>
  <div class="el-home">
    <el-row :gutter="10" v-if="studentInfo.showType != 3">
        <el-col :span="10">
            <el-row class="content" style="height: 200px;">
                <el-row style="border-bottom:2px solid #f0f2f5;">
                  <el-col :span="12"><p class="titleClass m10">个人信息</p></el-col>
                  <el-col :span="12" style="text-align:right;"><p class="gd m10" @click="userInfoAll">更多 >></p></el-col>
                </el-row>
                <el-row style="padding: 10px;font-size: 16px;">
                    <div style="display: flex">
                        <div class="user_info">函授站<span></span></div>
                        <div>：{{userInfo.corSchoolName}}</div>
                    </div>
                    <div style="display: flex">
                        <div class="user_info">姓名<span></span></div>
                        <div>：{{userInfo.studentName}}</div>
                    </div>
                    <div style="display: flex">
                        <div class="user_info">身份证<span></span></div>
                        <div>：{{userInfo.studentIdCard}}</div>
                    </div>
                    <div style="display: flex">
                        <div class="user_info">学号<span></span></div>
                        <div>：{{userInfo.studentNo || '-'}}</div>
                    </div>
                    <div style="display: flex">
                        <div class="user_info">专业<span></span></div>
                        <div>：{{userInfo.professionalName}}</div>
                    </div>
                </el-row>
            </el-row>
        </el-col>
        <el-col :span="14">
            <el-row class="content"  style="height: 200px;">
                <el-row style="border-bottom:2px solid #f0f2f5;">
                  <el-col :span="12"><p class="titleClass m10">通知公告</p></el-col>
                  <el-col :span="12" style="text-align:right;"><p class="gd m10" @click="moreInfo">更多 >></p></el-col>
                </el-row>
                <el-row style="border-bottom:1px solid #f0f2f5;" class="notice" v-for='(item,index) in messageAcceptList' :key="index"  @click.native="getNoticeInfo(index)">
                  <el-col :span="18" class="limit_line_one">
                    <p style="float: left;">
                      <span class="spanClass" :style="item.messageAcceptState == 2?'background:red;':''">&nbsp;</span>
                      通知：
                    </p>
                    <el-row class="limit_line_one" :style="(item.messageType == 7 || item.messageType ==2?'line-height:20px;':'line-height:20px;')" v-html="item.messageTitle"></el-row>
                  </el-col>
                  <el-col :span="6" class="limit_line_one" style="text-align:center;"><p style="margin-right:10px;">{{item.messageAddTime}}</p></el-col>
                </el-row>
                <template v-if="messageAcceptList.length <= 0">
                    <div style="color: #909399;text-align: center;font-size: 14px;margin-top: 30px;">
                        <i class="el-icon-document" style="font-size: 40px;"></i></br>
                        暂无通知公告
                    </div>
                </template>
            </el-row>
        </el-col>
    </el-row>
    <el-row class="content" v-if="studentInfo.showType != 3">
      <el-row style="border-bottom:1px solid #f0f2f5;">
        <el-col :span="20"><p class="titleClass m10">当前学期</p></el-col>
        <el-col :span="4" style="text-align:right;"><p class="gd m10" @click="onlineLearning()">更多 >></p></el-col>
      </el-row>
      <el-row style="height: calc(100% - 63px);margin-top: 10px;">
          <courseList v-if='teachingPlanCourseList.length > 0' :list="teachingPlanCourseList"></courseList>
          <el-empty v-if="teachingPlanCourseList.length <= 0" :image-size="80" description="暂无课程信息"></el-empty>
      </el-row>
    </el-row>
    <el-row class="content" style="height: calc(100vh - 100px);" v-if="studentInfo.showType == 3">
      <el-row style="border-bottom:1px solid #f0f2f5;">
        <el-col :span="20"><p class="titleClass m10">学前辅导</p></el-col>
        <el-col :span="4" style="text-align:right;"><p class="gd m10" @click="onlineLearning_()">更多 >></p></el-col>
      </el-row>
      <el-row style="height: calc(100% - 63px);margin-top: 10px;">
          <courseListxqfd v-if='teachingPlanCourseList.length > 0' :list="teachingPlanCourseList"></courseListxqfd>
          <el-empty v-if="teachingPlanCourseList.length <= 0" :image-size="80" description="暂无课程信息"></el-empty>
      </el-row>
    </el-row>
    <el-dialog
        title=""
        :visible.sync="show"
        width="1000px"
        >
        <el-descriptions :colon="false" >
            <el-descriptions-item label="标题："><span v-html="noticeInfo.messageTitle"></span></el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false">
            <el-descriptions-item label="时间：">{{noticeInfo.messageAddTime}} </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false">
            <el-descriptions-item label="内容：">
                <el-row v-html="noticeInfo.messageConcat"></el-row>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" v-if="!$isEmpty(noticeInfo.courseResourceList)">
            <el-descriptions-item label="附件：">
                <template v-for="(item,index) in noticeInfo.courseResourceList">
                    <p>
                        <el-link :underline="false" type="primary" style="padding: 0;" :href="$isHttp(item.courseResourceUrl)">
                            {{item.courseResourceName}}
                        </el-link>
                    </p>
                </template>
            </el-descriptions-item>
        </el-descriptions>
        <!-- <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="show = false">确 定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { getStorageKeyForRoleTag,getStudentInfoKeyForRoleTag } from "@/common/ulit";
import courseList from "@/components/courseList"; //学期课程
import courseListxqfd from "@/components/courseListxqfd"; // 学前辅导
import png from "@/images/course.png";
export default {
  name: "Home",
  components: {
    courseList: courseList,
    courseListxqfd: courseListxqfd,
  },
  data() {
    return {
        studentInfo:{},
        messageAcceptList: [], //通知公告List
        teachingPlanCourseList: [], //课程数据List
        noticeInfo: {},
        show: false,
        userInfo: {},
        png: png,
        superintendentPromptTime:43200000 //督学提示间隔时长 单位为毫秒 默认 12 小时
    };
  },
  created() {
    const stuInfo = sessionStorage.getItem(getStudentInfoKeyForRoleTag()); //将学生信息存入缓存
    if(stuInfo != null && stuInfo != ""){
       this.studentInfo = JSON.parse(stuInfo);
    }
    console.log(this.studentInfo.showType)
    if(this.studentInfo.showType == 3){
        this.getIndex();
    }else{
        this.getIndex();
        this.getPersonalInfo();
        this.getOpenProgressBar();
        this.getSuperintendentPromptTime();
    }
  },
  methods: {
    moreInfo() {
      this.$router.push({ name: "Notice" });
    },
    userInfoAll() {
      this.$router.push({ name: "UserInfo" });
    },
    onlineLearning() {
      this.$router.push({ name: "OnlineLearning" });
    },
    onlineLearning_(){
        this.$router.push({ name: "PreschoolTutoring" });
    },
    getPersonalInfo() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$store
        .dispatch("user/getPersonalInfo")
        .then((ret) => {
          this.loading.close();
          if (ret.code === 0 || ret.code === "0") {
            this.userInfo = ret.data;
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getIndex() {
      this.$store.dispatch("getIndex").then((ret) => {
        if (ret.code === 0 || ret.code === "0") {
          this.messageAcceptList = ret.messageAcceptList; //通知公告List
          this.teachingPlanCourseList = ret.teachingPlanCourseList; //课程数据List
          setTimeout(() => {
            for (let i in this.messageAcceptList) {
              if (this.messageAcceptList[i].messageAcceptState == 2) {
                // sessionStorage.setItem(getStorageKeyForRoleTag(''),)
                this.$notify({
                  title: "您有通知公告未读",
                  position: "bottom-right",
                  type: "warning",
                  customClass: "newClass",
                  message: "立即查看",
                  onClick: () => {
                    this.$notify.closeAll();
                    this.moreInfo();
                  },
                });
                break;
              }
            }
          }, 500);
        } else {
          this.$message({
            message: ret.msg,
            type: "warning",
          });
        }
      });
    },
    getNoticeInfo(index) {
      //获取通知公告详情
      this.$store.dispatch("user/getNoticeInfo", {
          messageId: this.messageAcceptList[index].messageId,
        })
        .then((ret) => {
          if (ret.code == 0) {
            this.messageAcceptList[index].messageAcceptState = 1;
            this.show = true;
            this.noticeInfo = ret.data;
          } else {
            this.$message({
              message: ret.msg,
              type: "warning",
            });
          }
        });
    },
    getOpenProgressBar(){//配置是否要开启进度条 第一遍播放没有进度条，完整看完后展示进度条
        this.$store.dispatch("user/getOpenProgressBar").then((ret) => {
            if (ret.code == 0) {
                localStorage.setItem(getStorageKeyForRoleTag("openProgressBar"),ret.data);	//是否开启进度条：1是 2否
            }
        });
    },
    getSuperintendentPromptTime(){//配置督学提示间隔时长 单位为毫秒
        this.$store.dispatch("user/getSuperintendentPromptTime").then((ret) => {
            if (ret.code == 0) {
                this.superintendentPromptTime = ret.data;
                this.getSuperintendentData();
            }
        }).catch(() => {
            this.getSuperintendentData();
        });
    },
    getSuperintendentData() { //获取学生端督学提示 首页调用 隔一天调用一次
        let lastTime = localStorage.getItem(getStorageKeyForRoleTag("superintendentData")); //上次展示的时间
        if(!this.$isEmpty(lastTime) && new Date().getTime() < Number(lastTime) + Number(this.superintendentPromptTime)){ //判断上一次与现在的相差时间， 12小时
            return;
        }
        this.$store.dispatch("user/getSuperintendentData").then((ret) => {
            if (ret.code === 0 || ret.code === "0") {
                if(!this.$isEmpty(ret.data)){
                    this.$notify({
                        title: '',
                        // type: 'warning',
                        duration: 10000,
                        position: 'bottom-right',
                        customClass: "superintendentDataClass",
                        dangerouslyUseHTMLString: true,
                        message: ret.data,
                        offset: 20,
                        onClose: () => { //关闭时调用这个  将当前展示的时间存入缓存，用于间隔多久调用一次
                            localStorage.setItem(getStorageKeyForRoleTag("superintendentData"),new Date().getTime());
                        },
                    });
                    // this.superintendentData = ret.data;
                }
            }
        }).catch(() => {

        });
    },
  },
};
</script>
 <style  lang="less">
@import "../styles/base.less";
.el-home {
  .el-descriptions-item__content p {
    margin: 0;
  }
  .el-descriptions-item__label {
    white-space: nowrap;
  }
  .content:first-child {
    margin-bottom: 10px;
    .spanClass {
      background: #73a1f7;
      float: left;
      width: 5px;
      height: 5px;
      margin: 7px 10px;
    }
    .notice {
      cursor: pointer;
      font-size: 14px;
      p {
        margin: 8px 0;
        line-height: 20px;
      }
    }
    .notice:hover {
      background-color: #56b9cf;
      color: white;
    }
  }
  .gd {
    margin-right: 10px;
    color: @primary_new;
    cursor: pointer;
  }
  .gd:hover {
    color: #a2a2a2;
  }
  .content {
    overflow: auto;
    padding: 0 20px;
    background-color: white;
    border-radius: 5px;
    height: calc(100vh - 290px);
    .el-link.el-link--primary {
      padding: 0 30px;
    }

    .m10 {
      margin: 10px 0;
      font-size: 16px;
    }

    .el-descriptions-item__cell {
      padding-bottom: 0;
      font-size: 14px;
    }
  }
  .user_info {
    width: 55px;
    height: 26px;
    text-align: justify; //主要对齐属性
    span {
      display: inline-block;
      padding-left: 100%;
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Home.vue